import { jsonArrayMember, jsonMember, jsonObject } from 'typedjson';
import { Guid, Nillable } from '@web/utils';
import { AdminSubscriptionContextOperationsResponse } from './admin-subscription-context-operations.response';
import { AdminSubscriptionBillingAddressResponse } from './admin-subscription-billing-address.response';
import { AdminSubscriptionDetailsShippingAddressResponse } from './admin-subscription-details-shipping-address.response';
import {
  ShippingMethodDictionaryResponse,
  SubscriptionCancelReason,
  SubscriptionNumber,
  SubscriptionStatus,
  SubscriptionSuspendReason,
} from '@web/shared/module/shop';
import { AdminPaymentMethodResponse } from './admin-payment-method.response';
import { AdminSubscriptionItemResponse } from './admin-subscription-item.response';
import { AdminOwnerResponse } from './admin-owner.response';

@jsonObject
export class AdminSubscriptionDetailsResponse {
  @jsonMember(String)
  public readonly id!: Guid;

  @jsonMember(Boolean)
  public readonly isLocked!: boolean;

  @jsonMember(String)
  public readonly number!: SubscriptionNumber;

  @jsonMember(Number)
  public readonly cardChargeDay!: number;

  @jsonMember(String)
  public readonly status!: SubscriptionStatus;

  @jsonMember(Number)
  public readonly totalPrice!: number;

  @jsonMember(Number)
  public readonly itemsPrice!: number;

  @jsonMember(Number)
  public readonly shippingPrice!: number;

  @jsonMember(Date)
  public readonly lastPaymentDate!: Date;

  @jsonMember(Date)
  public readonly nextPaymentDate?: Nillable<Date>;

  @jsonMember(Date)
  public readonly cancelledDate?: Nillable<Date>;

  @jsonMember(Date)
  public readonly suspendedDate?: Nillable<Date>;

  @jsonMember(Date)
  public readonly resumedDate?: Nillable<Date>;

  @jsonMember(Date)
  public readonly cardChargeDayChangedDate?: Nillable<Date>;

  @jsonMember(AdminOwnerResponse)
  public readonly owner?: Nillable<AdminOwnerResponse>;

  @jsonMember(String)
  public readonly cancelReason!: Nillable<SubscriptionCancelReason>;

  @jsonMember(String)
  public readonly suspendReason!: Nillable<SubscriptionSuspendReason>;

  @jsonMember(AdminPaymentMethodResponse)
  public readonly paymentMethod!: AdminPaymentMethodResponse;

  @jsonMember(ShippingMethodDictionaryResponse)
  public readonly shippingMethod!: ShippingMethodDictionaryResponse;

  @jsonMember(AdminSubscriptionBillingAddressResponse)
  public readonly billingAddress!: AdminSubscriptionBillingAddressResponse;

  @jsonArrayMember(AdminSubscriptionItemResponse)
  public readonly items!: AdminSubscriptionItemResponse[];

  @jsonMember(AdminSubscriptionDetailsShippingAddressResponse)
  public readonly shippingAddress!: AdminSubscriptionDetailsShippingAddressResponse;

  @jsonMember(AdminSubscriptionContextOperationsResponse)
  public readonly contextOperations!: AdminSubscriptionContextOperationsResponse;
}
